module.exports = __webpack_public_path__ + "static/media/error.4d3060ae.svg";